export default {
  slider_heading:       '1. Quer um empréstimo pessoal de quanto?',
  installments_heading: '2. Quer pagar em quantas parcelas?',

};
